module.exports = __webpack_public_path__ + "../static/img/server-fail.0f430c15.png";